import { NextSeo } from 'next-seo';
import React from 'react';
import { withAuth } from '~/auth';
import ProductList from '~/components/products-list/products-list';
import { useTranslate } from '~/i18n';

const ProductsList = () => {
   const { translate } = useTranslate();

   return (
      <>
         <NextSeo
            title={translate({
               id: 'pageTitles:my products',
            })}
         />
         <ProductList />
      </>
   );
};

export default withAuth(ProductsList);
